//MyRightModal
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  Slide,
  DialogTitle,
  Typography,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
const styles = (theme) => ({
  dialog: {
    margin: "0px 0px 0px auto",
    right: "0px",
    left: "auto",
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
  },
  DialogTitle: {
    padding: "10px 24px",
  },
  myTitle: {
    lineHeight: "2.5rem",
    float: "left",
    color: "#ffffff",
    fontWeight: 600,
  },
  closeIcon: {
    padding: "5px",
    color: "#ffffff",
    cursor: "pointer",
    float: "right",
  },
  dialogcontent: {
    backgroundColor: "#fcfcfc",
    padding: "1rem 1.5rem",
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

class MyRightModal extends Component {
  render() {
    const { classes, children } = this.props;
    return (
      <Dialog
        className={classes.dialog}
        maxWidth="sm"
        fullScreen
        open={this.props.open || false}
        onClose={this.props.onClose}
        TransitionComponent={Transition}
      >
        <DialogTitle
          style={{
            backgroundColor: this.props.bgColor ? this.props.bgColor : "gray",
          }}
          className={classes.DialogTitle}
        >
          <Typography className={classes.myTitle} variant="h4">
            {this.props.title}
          </Typography>

          <Tooltip arrow title="close">
            <IconButton
              className={classes.closeIcon}
              size="small"
              onClick={this.props.onClose}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </DialogTitle>

        <DialogContent
          className={classes.dialogcontent} dividers>
          {children}
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(styles)(MyRightModal);
